module.exports = __webpack_public_path__ + "static/img/logo.cf6e5589.svg";